import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

import { ReactComponent as LeftArrow } from "../../../../assets/appearencePage/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../assets/appearencePage/arrow-left-dark.svg";
import { ReactComponent as RightExpandArrow } from "../../../../assets/settingPage/arrow-left 2.svg";
import { ReactComponent as RightExpandArrowDark } from "../../../../assets/settingPage/arrow-left 2-dark.svg";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as MainIconSvg } from "../../../../assets/settingPage/setting-2 2.svg";
import { ReactComponent as LogoutSvg } from "../../../../assets/settingPage/Logout.svg";
import { ReactComponent as LogoutSvgDark } from "../../../../assets/settingPage/Logout-dark.svg";

import { ReactComponent as LinkBlack } from "../../../../assets/settingPage/sideBar/link 2.svg";
import { ReactComponent as UserBlack } from "../../../../assets/settingPage/sideBar/user-square.svg";
import { ReactComponent as LockBlack } from "../../../../assets/settingPage/sideBar/lock.svg";
import { ReactComponent as DollarBlack } from "../../../../assets/settingPage/sideBar/dollar-circle.svg";
import { ReactComponent as DollarWhite } from "../../../../assets/settingPage/sideBar/dollar-circle 2.svg";
import OgImage from "../../../../assets/landingPages/homePage/Hero.png";

// redux
import { useDispatch, useSelector } from "react-redux";
import {
  logoutUser,
  resetUser as resetAuthUser,
} from "../../../../redux/slices/auth/authSlice";
import { resetLinkList } from "../../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import useLocales from "../../../../hooks/useLocales";
import useSettings from "../../../../hooks/useSettings";

const HomeIndex = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { translate } = useLocales();
  const { themeDirection } = useSettings();
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    if (width >= 768) {
      navigate("/dashboard/setting");
    }
    const sizeHandler = () => {
      setWidth(window.innerWidth);
      if (window.innerWidth >= 768) {
        navigate("/dashboard/setting");
      }
    };
    window.addEventListener("resize", sizeHandler);
    return () => {
      window.removeEventListener("resize", sizeHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logoutaHndler = () => {
    dispatch(logoutUser());
    dispatch(resetLinkList());
    dispatch(resetAuthUser());
    navigate("/auth/login");
  };
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Setting | Bil.Bio</title>
        <meta property="og:title" content="Setting | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      <div className="h-screen flex flex-col justify-between text-heading_color">
        <div>
          <div className="mt-10 mb-10 ">
            <Link className="relative items-center gap-3" to={"/dashboard"}>
              <div className="absolute inset-y-0 start-0 flex items-center justify-center">
                {darkMode ? (
                  <LeftArrowDark
                    className={`h-[20px] w-[20px] ${
                      themeDirection === "rtl" ? "transform -scale-x-100" : ""
                    }`}
                  />
                ) : (
                  <LeftArrow
                    className={`h-[20px] w-[20px] ${
                      themeDirection === "rtl" ? "transform -scale-x-100" : ""
                    }`}
                  />
                )}
              </div>
              <h6 className="w-full text-center text-body_copy1_b dark:text-color_v1_dark">
                {/* Profile */}
                {translate("cms.profile")}
              </h6>
            </Link>
          </div>
          <div className="bg-light_bg_v5 dark:bg-dark-secondary flex flex-col gap-5 rounded-lg p-5">
            <div className="flex items-center gap-3">
              <div
                style={{
                  boxShadow: darkMode
                    ? ""
                    : "0px 0px 10px rgba(217, 217, 217, 0.1), -5px 6px 10px rgba(170, 170, 170, 0.3)",
                }}
                className="flex justify-center items-center p-2 bg-gradient-to-tl from-[#000000] to-[#494949] rounded-[10px]  "
              >
                <MainIconSvg />
              </div>

              <h6 className="text text-small1_bold dark:text-color_v1_dark">
                {/* Settings */}
                {translate("biolink_title.settings")}
              </h6>
            </div>
            <div className="flex flex-col gap-2.5">
              <Link to={"../page"}>
                <div className="flex justify-between py-[7px] px-2 items-center">
                  <div className="flex gap-[17px]">
                    <LinkBlack
                      className="stroke-[#1E1E1E] dark:stroke-[#FFFFFF]"
                      height={20}
                      width={20}
                    />
                    <div className="text-small1 dark:text-color_v1_dark">
                      {/* Page */}
                      {translate("cms.page")}
                    </div>
                  </div>
                  <div>
                    {darkMode ? (
                      <RightExpandArrowDark
                        className={`${
                          themeDirection === "rtl"
                            ? "transform -scale-x-100"
                            : ""
                        }`}
                      />
                    ) : (
                      <RightExpandArrow
                        className={`${
                          themeDirection === "rtl"
                            ? "transform -scale-x-100"
                            : ""
                        }`}
                      />
                    )}
                  </div>
                </div>
              </Link>
              <Link to={"../account"}>
                <div className="flex justify-between py-[7px] px-2 items-center">
                  <div className="flex gap-[17px]">
                    <UserBlack
                      className="stroke-[#1E1E1E] dark:stroke-[#FFFFFF]"
                      height={20}
                      width={20}
                    />
                    <div className="text-small1 dark:text-color_v1_dark">
                      {/* Account */}
                      {translate("cms.account")}
                    </div>
                  </div>
                  <div>
                    {darkMode ? (
                      <RightExpandArrowDark
                        className={`${
                          themeDirection === "rtl"
                            ? "transform -scale-x-100"
                            : ""
                        }`}
                      />
                    ) : (
                      <RightExpandArrow
                        className={`${
                          themeDirection === "rtl"
                            ? "transform -scale-x-100"
                            : ""
                        }`}
                      />
                    )}
                  </div>
                </div>
              </Link>
              <Link to={"../security"}>
                <div className="flex justify-between py-[7px] px-2 items-center">
                  <div className="flex gap-[17px]">
                    <LockBlack
                      height={20}
                      width={20}
                      className="stroke-[#1E1E1E] dark:stroke-[#FFFFFF]"
                    />
                    <div className="text-small1 dark:text-color_v1_dark">
                      {/* Security */}
                      {translate("cms.security")}
                    </div>
                  </div>
                  <div>
                    {darkMode ? (
                      <RightExpandArrowDark
                        className={`${
                          themeDirection === "rtl"
                            ? "transform -scale-x-100"
                            : ""
                        }`}
                      />
                    ) : (
                      <RightExpandArrow
                        className={`${
                          themeDirection === "rtl"
                            ? "transform -scale-x-100"
                            : ""
                        }`}
                      />
                    )}
                  </div>
                </div>
              </Link>
              <Link to={"../billings"}>
                <div className="flex justify-between py-[7px] px-2 items-center">
                  <div className="flex gap-[17px]">
                    {darkMode ? (
                      <DollarWhite height={20} width={20} />
                    ) : (
                      <DollarBlack height={20} width={20} />
                    )}
                    <div className="text-small1 dark:text-color_v1_dark">
                      {/* Billings */}
                      {translate("cms.billings")}
                    </div>
                  </div>
                  <div>
                    {darkMode ? (
                      <RightExpandArrowDark
                        className={`${
                          themeDirection === "rtl"
                            ? "transform -scale-x-100"
                            : ""
                        }`}
                      />
                    ) : (
                      <RightExpandArrow
                        className={`${
                          themeDirection === "rtl"
                            ? "transform -scale-x-100"
                            : ""
                        }`}
                      />
                    )}
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div
          onClick={logoutaHndler}
          className="flex gap-2.5 items-center my-11"
        >
          {darkMode ? (
            <LogoutSvgDark
              className={`${
                themeDirection === "rtl" ? "transform -scale-x-100" : ""
              }`}
            />
          ) : (
            <LogoutSvg
              className={`${
                themeDirection === "rtl" ? "transform -scale-x-100" : ""
              }`}
            />
          )}
          <div className="text-small1 dark:text-color_v1_dark">
            {/* Logout */}
            {translate("header.logout")}
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeIndex;
